// extracted by mini-css-extract-plugin
export default {"root":"root-RZcQ5M","body":"body-hnN_3y"};